var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "timeline",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M5,9h14c0.6,0,1,0.4,1,1v4c0,0.6-0.4,1-1,1H5c-0.6,0-1-0.4-1-1v-4C4,9.4,4.4,9,5,9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M1,0h14c0.6,0,1,0.4,1,1v4c0,0.6-0.4,1-1,1H1C0.4,6,0,5.6,0,5V1C0,0.4,0.4,0,1,0z M9,18h14c0.6,0,1,0.4,1,1v4 c0,0.6-0.4,1-1,1H9c-0.6,0-1-0.4-1-1v-4C8,18.4,8.4,18,9,18z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.b0195e30.svg";
export { ForwardRef as ReactComponent };